import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { getTipoCambioDolar, getReporteToChart, getActividades, clearErrors, setInicializarDocumento } from '../../actions';
import { condicionVenta, medioPago, tipoMoneda } from '../../catalogos';
import { ValidarEmisor, ValidarLogin } from '../../util';
import InputField from '../nuevoDocumento/InputField';
import RenderHeader from '../shared/RenderHeader';
import BarChart from './BarChart';
import LineChart from './LineChart';
import CardHeader from './CardHeader';
import BasicMessage from '../messages/basicMessage';
import { messageTypeEnum } from '../../enum';
import { meses } from "../../catalogos/index";

let facturas = {
    TotalVentas: 0,
    TotalImpuestos: 0,
    TotalMercancias: 0,
    TotalServicios: 0,
}

let tiquetes = {
    TotalVentas: 0,
    TotalImpuestos: 0,
    TotalMercancias: 0,
    TotalServicios: 0,
}

let ventasTotales = {
    TotalVentas: 0,
    TotalImpuestos: 0,
    TotalMercancias: 0,
    TotalServicios: 0,
}

let notasCredito = {
    TotalVentas: 0,
    TotalImpuestos: 0,
    TotalMercancias: 0,
    TotalServicios: 0,
}

let mesesLineChart = {
    Enero: null,
    Febrero: null,
    Marzo: null,
    Abril: null,
    Mayo: null,
    Junio: null,
    Julio: null,
    Agosto: null,
    Septiembre: null,
    Octubre: null,
    Noviembre: null,
    Diciembre: null
}

let impuestoLineChart = {
    Enero: null,
    Febrero: null,
    Marzo: null,
    Abril: null,
    Mayo: null,
    Junio: null,
    Julio: null,
    Agosto: null,
    Septiembre: null,
    Octubre: null,
    Noviembre: null,
    Diciembre: null
}

const Dashboard = (props) => {

    const { token } = ValidarLogin(props);
    const { emisor } = ValidarEmisor(props);
    const [mgType, setMgType] = useState('');
    const [message, setMessage] = useState('');
    const [actividades, setActividades] = useState([]);
    const [ventasTotal, setVentasTotal] = useState(null);
    const [selectBarChart, setSelectBarChart] = useState({
        actividad: '01',
        medioPago: '01',
        condicionVenta: '01',
        tipoMoneda: 'CRC',
        mes: `${new Date().getMonth() + 1}`
    })
    const [selectLineChart, setSelectLineChart] = useState({
        actividad: '01',
        tipoMoneda: 'CRC'
    })
    const [facturasState, setFacturasState] = useState(null);
    const [tiquetesState, setTiquetesState] = useState(null);
    const [montoMesesState, setMontoMesesState] = useState(null);
    const [impuestoMesesState, setImpuestMesesState] = useState(null);
    const [validarActividad, setValidarActividad] = useState(false);
    const [notasCreditoState, setNotasCreditoState] = useState(null);
    const { tipoCambioDolar, actividadesState, dashboardState, errorState } = props;

    useEffect(() => {

        if (token !== null && emisor) {
            props.getActividades(token?.access_token, emisor.Identificacion.Numero);


            props.getTipoCambioDolar(moment().format('DD'), moment().format('MM'), moment().format('YYYY'), true);

            let fechaInicio = `${new Date().getFullYear()}-01-01`;
            let fechaFin = new Date().getFullYear() + '-' + (new Date().getMonth() + 2) + '-01';

            props.getReporteToChart(token?.access_token, emisor.Id, fechaInicio, fechaFin);
        }

        return () => {
            props.setInicializarDocumento(false);
        }

    }, [])

    useEffect(() => {

        if (actividadesState?.actividades.length > 0) {
            setSelectBarChart({
                ...selectBarChart,
                actividad: actividadesState?.actividades[0].CodigoActividad,
            })
            setSelectLineChart({
                ...selectLineChart,
                actividad: actividadesState?.actividades[0].CodigoActividad,
            })
            setValidarActividad(true);
            const actividadItems = [];
            actividadesState.actividades.map(item => {
                actividadItems.push({ value: item.CodigoActividad, display: item.Actividad });
            });
            setActividades(actividadItems);
        }
        else {
            setMgType(messageTypeEnum.error);
            setMessage(`Debe asignar una actividad económica, en la pantalla de "Emisor" puede hacerlo`);
        }

    }, [actividadesState]);

    useEffect(() => {

        if (dashboardState && validarActividad) {

            resetBarChart();
            resetLineChart();

            let dataLineChart = dashboardState.filter(x =>
                x.CodigoActividad === selectLineChart.actividad &&
                x.CodigoMoneda === selectLineChart.tipoMoneda
            );

            montosLineChart(dataLineChart);

            let dataBarChart = dashboardState.filter(x =>
                //x.FechaEmision === `${new Date().getFullYear()}-${new Date().getMonth() + 1}` &&
                x.FechaEmision === `${new Date().getFullYear()}-${selectBarChart.mes}` &&
                x.CodigoActividad === selectBarChart.actividad &&
                x.MedioPago === selectBarChart.medioPago &&
                x.CondicionVenta === selectBarChart.condicionVenta &&
                x.CodigoMoneda === selectBarChart.tipoMoneda);

            dataBarChart.map((doc) => {

                if (doc.TipoDocumento === '01') {
                    montosBarChart(facturas, doc);
                }
                if (doc.TipoDocumento === '03') {
                    montosBarChart(notasCredito, doc);
                }
                if (doc.TipoDocumento === '04') {
                    montosBarChart(tiquetes, doc);
                }

            })

            ventasTotales.TotalImpuestos = facturas.TotalImpuestos + tiquetes.TotalImpuestos;
            ventasTotales.TotalServicios = facturas.TotalServicios + tiquetes.TotalServicios;
            ventasTotales.TotalMercancias = facturas.TotalMercancias + tiquetes.TotalMercancias;
            ventasTotales.TotalVentas = facturas.TotalVentas + tiquetes.TotalVentas;
            setFacturasState(facturas);
            setTiquetesState(tiquetes);
            setVentasTotal(ventasTotales);
            setNotasCreditoState(notasCredito);
            setMontoMesesState(mesesLineChart);
            setImpuestMesesState(impuestoLineChart);

        }

    }, [dashboardState, selectBarChart, selectLineChart, validarActividad])

    useEffect(() => {
        if (errorState && errorState.error !== null) {
            setMgType(errorState?.error ? messageTypeEnum.error : messageTypeEnum.success);
            setMessage(errorState.message);
        }
        else {
            setMgType('');
        }
    }, [errorState]);

    if (token === null || emisor === null) {
        return <Redirect to='/login' />;
    }

    const montosLineChart = (dataLineChart) => {
        dataLineChart.map(doc => {
            switch (doc.FechaEmision) {
                case (`${new Date().getFullYear()}-1`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Enero += doc.TotalVentas;
                        impuestoLineChart.Enero += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Enero -= doc.TotalVentas;
                        impuestoLineChart.Enero -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-2`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Febrero += doc.TotalVentas;
                        impuestoLineChart.Febrero += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Febrero -= doc.TotalVentas;
                        impuestoLineChart.Febrero -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-3`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Marzo += doc.TotalVentas;
                        impuestoLineChart.Marzo += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Marzo -= doc.TotalVentas;
                        impuestoLineChart.Marzo -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-4`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Abril += doc.TotalVentas;
                        impuestoLineChart.Abril += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Abril -= doc.TotalVentas;
                        impuestoLineChart.Abril -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-5`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Mayo += doc.TotalVentas;
                        impuestoLineChart.Mayo += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Mayo -= doc.TotalVentas;
                        impuestoLineChart.Mayo -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-6`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Junio += doc.TotalVentas;
                        impuestoLineChart.Junio += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Junio -= doc.TotalVentas;
                        impuestoLineChart.Junio -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-7`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Julio += doc.TotalVentas;
                        impuestoLineChart.Julio += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Julio -= doc.TotalVentas;
                        impuestoLineChart.Julio -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-8`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Agosto += doc.TotalVentas;
                        impuestoLineChart.Agosto += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Agosto -= doc.TotalVentas;
                        impuestoLineChart.Agosto -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-9`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Septiembre += doc.TotalVentas;
                        impuestoLineChart.Septiembre += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Septiembre -= doc.TotalVentas;
                        impuestoLineChart.Septiembre -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-10`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Octubre += doc.TotalVentas;
                        impuestoLineChart.Octubre += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Octubre -= doc.TotalVentas;
                        impuestoLineChart.Octubre -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-11`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Noviembre += doc.TotalVentas;
                        impuestoLineChart.Noviembre += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Noviembre -= doc.TotalVentas;
                        impuestoLineChart.Noviembre -= doc.TotalImpuestos;
                    }
                    break;
                case (`${new Date().getFullYear()}-12`):
                    if (doc.TipoDocumento !== '03') {
                        mesesLineChart.Diciembre += doc.TotalVentas;
                        impuestoLineChart.Diciembre += doc.TotalImpuestos;
                    } else {
                        mesesLineChart.Diciembre -= doc.TotalVentas;
                        impuestoLineChart.Diciembre -= doc.TotalImpuestos;
                    }
                    break;
                default:
                    break;
            }
        })
    }

    const montosBarChart = (docType, doc) => {
        docType.TotalImpuestos += doc.TotalImpuestos;
        docType.TotalMercancias += doc.TotalMercancias;
        docType.TotalServicios += doc.TotalServicios;
        docType.TotalVentas += doc.TotalVentas;
    }

    const resetLineChart = () => {
        mesesLineChart.Enero = null;
        mesesLineChart.Febrero = null;
        mesesLineChart.Marzo = null;
        mesesLineChart.Abril = null;
        mesesLineChart.Mayo = null;
        mesesLineChart.Junio = null;
        mesesLineChart.Julio = null;
        mesesLineChart.Agosto = null;
        mesesLineChart.Septiembre = null;
        mesesLineChart.Octubre = null;
        mesesLineChart.Noviembre = null;
        mesesLineChart.Diciembre = null;

        impuestoLineChart.Enero = null;
        impuestoLineChart.Febrero = null;
        impuestoLineChart.Marzo = null;
        impuestoLineChart.Abril = null;
        impuestoLineChart.Mayo = null;
        impuestoLineChart.Junio = null;
        impuestoLineChart.Julio = null;
        impuestoLineChart.Agosto = null;
        impuestoLineChart.Septiembre = null;
        impuestoLineChart.Octubre = null;
        impuestoLineChart.Noviembre = null;
        impuestoLineChart.Diciembre = null;
    }

    const resetBarChart = () => {
        tiquetes.TotalVentas = 0;
        tiquetes.TotalServicios = 0;
        tiquetes.TotalMercancias = 0;
        tiquetes.TotalImpuestos = 0;
        facturas.TotalVentas = 0;
        facturas.TotalServicios = 0;
        facturas.TotalMercancias = 0;
        facturas.TotalImpuestos = 0;
        notasCredito.TotalVentas = 0;
        notasCredito.TotalServicios = 0;
        notasCredito.TotalMercancias = 0;
        notasCredito.TotalImpuestos = 0;
    }

    const handledSelectBarChart = (option) => {
        setFacturasState(null);
        setNotasCreditoState(null);
        setTiquetesState(null);
        setSelectBarChart({
            ...selectBarChart,
            ...option
        })
    }

    const handledSelectLineChart = (option) => {
        setMontoMesesState(null);
        setImpuestMesesState(null)
        setSelectLineChart({
            ...selectLineChart,
            ...option
        })
    }

    const closeMessage = () => {
        props.clearErrors();
    };

    return (
        <>

            <RenderHeader titulo="TABLERO" />

            <div className={emisor?.FechaVencePlan ? "ui stackable six column grid" : "ui stackable four column grid"}>
                <div className="column">
                    <CardHeader titulo="T. Impuestos" monto={ventasTotales.TotalImpuestos.toFixed(2)} icon={"arrow circle down"} style={"red"} />
                </div>
                <div className="column">
                    <CardHeader titulo="T. Ventas" monto={ventasTotales.TotalVentas.toFixed(2)} icon={"arrow circle up"} style={"blue"} />
                </div>
                <div className="column">
                    <CardHeader titulo="Compra" monto={tipoCambioDolar?.tipoCambioDolar?.compra} icon={"dollar sign"} style={"green"} />
                </div>
                <div className="column">
                    <CardHeader titulo="Venta" monto={tipoCambioDolar?.tipoCambioDolar?.venta} icon={"dollar sign"} style={"green"} />
                </div>
                {emisor?.FechaVencePlan && <div className="column">
                    <CardHeader titulo="Vence Plan" monto={moment(emisor.FechaVencePlan).format('YYYY-MM-DD')} icon={"calendar"} style={"orange"} />
                </div>}
                {emisor?.FechaVencePlan &&<div className="column">
                     <CardHeader titulo="Documentos" monto={emisor.CantidadDocumentos} icon={"file"} style={"purple"} />
                </div>}
            </div>

            <div style={{ marginTop: "50px" }}>
                <form className="ui form container-select">

                    <div className="ui grid">
                        <div className="ten wide column">
                            <div className="column">
                                <InputField
                                    label="Actividad"
                                    type="select"
                                    options={actividades}
                                    onChange={(e) => handledSelectLineChart({ actividad: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="six wide column">
                            <InputField
                                label="Moneda"
                                type="select"
                                options={tipoMoneda}
                                onChange={(e) => handledSelectLineChart({ tipoMoneda: e.target.value })}
                            />
                        </div>
                    </div>
                </form>

                <div className="ui grid container-lineChart" >
                    <div className="sixteen wide column">
                        <div className="chart"><LineChart data={montoMesesState} impuestos={impuestoMesesState} /></div>
                        <hr />
                        <div className="title-chart">
                            <h2>Total de ventas por mes</h2>
                        </div>
                    </div>
                </div>

            </div>

            <BasicMessage message={message} type={mgType} onClick={() => closeMessage()} />

            <form className="ui form container-select" >
                <div className="ui equal width grid stackable">
                    <div className="column">
                        <InputField
                            label="Mes"
                            type="select"
                            options={meses}
                            value={selectBarChart.mes}
                            onChange={(e) => handledSelectBarChart({ mes: e.target.value })}
                        />
                    </div>
                    <div className="column">
                        <InputField
                            label="Actividad"
                            type="select"
                            options={actividades}
                            onChange={(e) => handledSelectBarChart({ actividad: e.target.value })}
                        />
                    </div>
                    <div className="column">
                        <InputField
                            label="Medio de pago"
                            type="select"
                            options={medioPago}
                            onChange={(e) => handledSelectBarChart({ medioPago: e.target.value })}
                        />
                    </div>
                    <div className="column">
                        <InputField
                            label="Condición de venta"
                            type="select"
                            options={condicionVenta}
                            onChange={(e) => handledSelectBarChart({ condicionVenta: e.target.value })}
                        />
                    </div>
                    <div className="column">
                        <InputField
                            label="Moneda"
                            type="select"
                            options={tipoMoneda}
                            onChange={(e) => handledSelectBarChart({ tipoMoneda: e.target.value })}
                        />
                    </div>
                </div>
            </form>

            <div className="ui stackable two column grid container-select">
                <div className="eight wide column">
                    <div className="eight wide column">
                        <div className="chart">
                            <BarChart data={ventasTotal} label={'Ventas'} />
                        </div>
                        <hr />
                        <div className="title-chart">
                            <h2>Total en Ventas</h2>
                        </div>
                    </div>
                </div>
                <div className="eight wide column">
                    <div className="chart">
                        <BarChart data={notasCreditoState} label={'Notas'} />
                    </div>
                    <hr />
                    <div className="title-chart">
                        <h2>Notas de Crédito</h2>
                    </div>
                </div>
            </div>
            <div className="ui stackable two column grid" >
                <div className="eight wide column">
                    <div className="chart">
                        <BarChart data={facturasState} label={'Facturas'} />
                    </div>
                    <hr />
                    <div className="title-chart">
                        <h2>Total ventas por Facturas</h2>
                    </div>
                </div>
                <div className="eight wide column">
                    <div className="chart">
                        <BarChart data={tiquetesState} label={'Tiquetes'} />
                    </div>
                    <hr />
                    <div className="title-chart">
                        <h2>Total ventas por Tiquetes</h2>
                    </div>
                </div>
            </div>

            <div className="margin-chart">
                <BasicMessage message={message} type={mgType} onClick={() => closeMessage()} />
            </div>


        </>
    )

}

const mapStateToProps = (state) => {
    return {
        loginState: state.loginState,
        errorState: state.errorState,
        emisorState: state.emisorState,
        dashboardState: state.dashboardState,
        actividadesState: state.actividadesState,
        tipoCambioDolar: state.tipoCambioDolarState,
    };
}

export default connect(mapStateToProps, {
    getTipoCambioDolar,
    setInicializarDocumento,
    getReporteToChart,
    getActividades,
    clearErrors
})(Dashboard);